/* eslint-disable @typescript-eslint/no-magic-numbers */
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Col, PageHeader, Row, Tooltip } from 'antd';
import { Block } from 'components/block';
import { useCurrentEditingBlock } from 'components/block/utils';
import { EditButton } from 'components/buttons/edit-button';
import { InfoCircleIcon, LanguagesGlobeIcon } from 'components/icons';
import { LanguageSkillCell } from 'components/language-skill-cell';
import { useEmployee } from 'hooks';
import { editLanguageSkillsModal } from 'user/modals/edit-language-skills-modal';
import styles from './styles.less';

export const LanguageBlock: FC = () => {
  const { t } = useTranslation('translation');

  const { employee, error } = useEmployee();

  const languages = employee?.languages || [];

  const { currentEditingBlock } = useCurrentEditingBlock();

  if (error || !employee) {
    return (
      <PageHeader ghost={false} title={t('Language Skills')}>
        <Alert type="error" message={error?.message} showIcon />
      </PageHeader>
    );
  }

  const lgSpan = languages.length + 1 >= 4 ? 6 : 8;
  const emsEnglishLevel = employee?.englishLevel;

  const infoCircle = (
    <Tooltip
      title={
        'This section shows the languages from EMS.\
     It is impossible to delete it, but you can add to them the level(except English).'
      }
    >
      <InfoCircleIcon />
    </Tooltip>
  );

  if (!languages.length && !employee.englishLevel) {
    return (
      <Block title={t('Languages')} subTitle={infoCircle}>
        <LanguagesGlobeIcon className={styles['globe-icon']} />
      </Block>
    );
  }

  const extra = !currentEditingBlock ? (
    <EditButton onClick={editLanguageSkillsModal} />
  ) : (
    <Tooltip title="Complete editing in another section to modify this">
      <div>
        <EditButton disabled={true} />
      </div>
    </Tooltip>
  );

  return (
    <Block title={t('Languages')} subTitle={infoCircle} extra={extra}>
      <Row gutter={[16, 16]}>
        {emsEnglishLevel && (
          <Col
            key={'ems-english'}
            span={24}
            sm={{ span: 12 }}
            lg={{ span: lgSpan }}
          >
            <LanguageSkillCell name={'English'} level={emsEnglishLevel} />
          </Col>
        )}
        {languages.map((language) => {
          const isOld = languages.find((l) => l.name === language.name);

          return (
            <Col
              key={language.name}
              span={24}
              sm={{ span: 12 }}
              lg={{ span: lgSpan }}
            >
              <LanguageSkillCell {...language} glow={!isOld} />
            </Col>
          );
        })}
      </Row>
    </Block>
  );
};
